import {useEffect} from 'react';
import {useDispatch} from 'react-redux';

import {scheduleSsoInvalidation} from '@/services/sso/ssoLinkRefreshScheduler';
import {invalidateSsoLink} from '@/state/slices/mediaSlice';

type UseSsoLinkRefreshParams = {
    expirationDate?: number | string;
    formattedSsoTemplate: string | null;
    disabled?: boolean;
};

const useSsoLinkRefresh = ({expirationDate, formattedSsoTemplate, disabled}: UseSsoLinkRefreshParams) => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (disabled) return;
        if (!expirationDate) return;
        if (!formattedSsoTemplate) return;

        return scheduleSsoInvalidation({
            expirationDate,
            onExpire: () => dispatch(invalidateSsoLink({ssoTemplate: formattedSsoTemplate})),
        });
    }, [expirationDate, disabled, dispatch, formattedSsoTemplate]);
};

export default useSsoLinkRefresh;
